import { render, staticRenderFns } from "./RenderComponent.vue?vue&type=template&id=f3151376&scoped=true&"
import script from "./RenderComponent.vue?vue&type=script&lang=js&"
export * from "./RenderComponent.vue?vue&type=script&lang=js&"
import style0 from "./RenderComponent.vue?vue&type=style&index=0&id=f3151376&lang=scss&scoped=true&"
import style1 from "./RenderComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3151376",
  null
  
)

export default component.exports